import { memo, useCallback } from "react";
import PropTypes from "prop-types";
import IconFacebookShare from "app/pages/.shared/static/icons/IconFacebookShare";
import waitForFacebookApi from "app/utils/waitForFacebookApi";
import "./FacebookShareButton.scss";

const FacebookShareButton = ({ label, quote, link, onClick }) => {
	const isFacebookSDKReady = waitForFacebookApi();

	const shareOnFacebook = useCallback(() => {
		// eslint-disable-next-line no-undef
		FB.ui(
			{
				method: "share",
				display: "dialog",
				mobile_iframe: true,
				quote: quote,
				href: link,
			},
			() => {
				if (typeof onClick === "function") {
					onClick();
				}
			}
		);
	}, [quote, link]);

	return (
		isFacebookSDKReady && (
			<div
				className="facebook-share-button"
				onClick={shareOnFacebook}
				data-testid="facebook-share-button"
			>
				<span className="facebook-share-button__icon">
					<IconFacebookShare height={20} width={20} />
				</span>
				<span className="facebook-share-button__label">{label}</span>
			</div>
		)
	);
};

FacebookShareButton.propTypes = {
	link: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	quote: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	onClick: PropTypes.func,
};

export default memo(FacebookShareButton);
